module.exports = __webpack_public_path__ + "static/media/cr.7920dae7.svg";